import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import Container from './Container';
import { useCombinedContext } from '../AnimationContext';

const CustomersContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
}));

const VideoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '640px',
  margin: '0 auto',
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius,
}));

const StyledVideo = styled('video')({
  width: '100%',
  height: 'auto',
});

const Customers: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [error, setError] = useState<string | null>(null);
  const { settings } = useCombinedContext();

  useEffect(() => {
    let stream: MediaStream | null = null;

    async function setupWebcam() {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video: true });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      } catch (err) {
        console.error('Error accessing webcam:', err);
        setError('Unable to access webcam. Please make sure you have granted the necessary permissions.');
      }
    }

    setupWebcam();

    return () => {
      // Clean up the video stream when the component unmounts
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
    };
  }, []);

  return (
    <motion.div
      initial={settings.initial}
      animate={settings.animate}
      exit={settings.exit}
      transition={settings.transition}
    >
      <CustomersContainer>
        <Container title="Live Webcam Feed">
          <VideoContainer>
            {error ? (
              <Typography color="error">{error}</Typography>
            ) : (
              <StyledVideo ref={videoRef} autoPlay playsInline muted />
            )}
          </VideoContainer>
        </Container>
      </CustomersContainer>
    </motion.div>
  );
};

export default Customers;